
import { uniqueNamesGenerator } from 'unique-names-generator';
import { SPONSOR_TYPES, SPONSOR_TYPES_VALUES } from './services/sponsors';

const MLB_PLAYERS = [
    'Barry Larkin',
    'Phil Niekro',
    'Jim Thome',
    'Adrian Beltre',
    'Charlie Gehringer',
    'Duke Snider',
    'Bryce Harper',
    'John Smoltz',
    'Roy Halladay',
    'Ryne Sandberg',
    'Ivan Rodriguez',
    'Joe Jackson',
    'Willie Stargell',
    'Carlton Fisk',
    'Roberto Alomar',
    'Jim Palmer',
    'Paul Molitor',
    'Roy Campanella',
    'Eddie Collins',
    'Mike Piazza',
    'Robin Yount',
    'Hank Greenberg',
    'Chipper Jones',
    'Vladimir Guerrero',
    'Cap Anson',
    'Rod Carew',
    'Juan Marichal',
    'Willie McCovey',
    'Justin Verlander',
    'Al Kaline',
    'Harmon Killebrew',
    'Ozzie Smith',
    'Manny Ramirez',
    'Brooks Robinson',
    'Cal Ripken Jr.',
    'Max Scherzer',
    'Eddie Mathews',
    'David Ortiz',
    'Mel Ott',
    'Carl Yastrzemski',
    'Whitey Ford',
    'Miguel Cabrera',
    'Steve Carlton',
    'Pete Alexander',
    'Dave Winfield',
    'Reggie Jackson',
    'Lefty Grove',
    'Oscar Charleston',
    'Clayton Kershaw',
    'Ernie Banks',
    'Bob Feller',
    'Frank Thomas',
    'Nap Lajoie',
    'Warren Spahn',
    'Ichiro Suzuki',
    'Wade Boggs',
    'Tony Gwynn',
    'George Brett',
    'Nolan Ryan',
    'Satchel Paige',
    'Jimmie Foxx',
    'Yogi Berra',
    'Jackie Robinson',
    'Joe Morgan',
    'Tris Speaker',
    'Josh Gibson',
    'Pete Rose',
    'Bob Gibson',
    'Sandy Koufax',
    'Mariano Rivera',
    'Albert Pujols',
    'Johnny Bench',
    'Derek Jeter',
    'Roberto Clemente',
    'Alex Rodriguez',
    'Christy Mathewson',
    'Randy Johnson',
    'Rickey Henderson',
    'Tom Seaver',
    'Cy Young',
    'Rogers Hornsby',
    'Frank Robinson',
    'Mike Schmidt',
    'Roger Clemens',
    'Joe DiMaggio',
    'Mike Trout',
    'Greg Maddux',
    'Ken Griffey Jr.',
    'Honus Wagner',
    'Pedro Martinez',
    'Stan Musial',
    'Walter Johnson',
    'Barry Bonds',
    'Mickey Mantle',
    'Lou Gehrig',
    'Ted Williams',
    'Ty Cobb',
    'Hank Aaron',
    'Willie Mays',
    'Babe Ruth'
];

const HEROIC_ADJECTIVES = [
    'colossaux',
    'monstrueux',
    'prodigieux',
    'énormes',
    'sublimes',
    'redoutables',
    'impressionnants',
    'avenants',
    'redoutables',
    'apocalyptiques',
    'gonflés',
    'pompeux',
    'superbes',
    'terrifiants',
    'somptueux',
    'opulents',
    'grandioses',
    'magnifiques',
    'tueurs',
    'frappants',
    'divins',
    'célestes',
    'déterminés',
    'graveleux',
    'courageux',
    'résolus',
    'spartiates',
    'imperturbables',
    'indéfectibles',
    'fougueux',
    'aventureux',
    'audacieux',
    'fringants',
    'aventureux',
    'insensés',
    'fous',
    'effrontés',
    'casse-cou',
    'téméraires',
    'inattentifs',
    'impétueux',
    'imprudents',
    'impulsifs',
    'imprudents',
    'écervelés',
    'exagérés',
    'trop confiants',
    'téméraires',
    'irréfléchis',
    'sauvages',
    'précipités',
]
const DETERMINANTS = ['les'];

export const TEAM_DEFAULT_LOGO = '<svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" height="92.56002" width="171.69131" version="1.1" viewBox="0 0 171.69131 92.56002"><path d="M157.40349.00016H14.31505A14.42141,14.42141,0,0,0,4.16912,4.12823,14.26059,14.26059,0,0,0,.00084,14.34117v63.851A14.1534,14.1534,0,0,0,4.15572,88.36491,14.3276,14.3276,0,0,0,14.31505,92.56H157.40349A14.35442,14.35442,0,0,0,171.6909,78.19217V14.32777A14.22038,14.22038,0,0,0,157.5783.00041Q157.49091-.00025,157.40349.00016Z" fill="#fff"/><path d="M166.66483,14.32777a9.19433,9.19433,0,0,0-9.08622-9.30118q-.08755-.001-.17512-.00038h-39.994l22.94562,38.34546,2.11765.268,1.34028,1.75577v1.63515l1.44751.29486,1.34028,1.82279v1.58153l1.50112.26806,1.51451,1.64854V56.292a24.84912,24.84912,0,0,0,6.03127,4.02084c2.02383.77737,2.25167,4.02085,3.47132,5.74981,1.52792,2.51973,3.61876,3.52494,3.17647,4.93224-1.01861,3.76619-4.87862,10.11912-8.47057,10.414H139.618v6.08488H157.4169a9.30157,9.30157,0,0,0,9.26161-9.34134l-.00027-.04063v-63.784" fill="#bf0d3e"/><path d="M68.82429,81.50267H61.94865c0-17.1824,5.80341-26.685,12.75948-28.5748.9516-.17423.4959-4.86522-.71035-6.29932H69.97694c-.64334,0-.26806-1.20625-.26806-1.20625l3.25688-6.95607-.44229-1.9032H60.48774L70.379,29.64718C70.83471,11.406,89.545,9.98525,100.81681,17.58465c6.70141,4.43633,7.21071,13.22858,6.70141,19.30005-.08041.38868-1.74237.134-1.74237.134s-1.13924,6.70141,1.83619,6.70141H120.7602c5.36112-.21445,10.53461,3.41771,10.53461,3.41771l1.25987-4.59716L103.752,5.02622h-89.437a9.382,9.382,0,0,0-6.621,2.68056,9.28811,9.28811,0,0,0-2.68056,6.621V78.19218a9.16749,9.16749,0,0,0,2.68056,6.59418,9.38191,9.38191,0,0,0,6.621,2.74758H72.376c-1.4207-2.43931-3.04244-5.21369-3.53834-6.03126" fill="#041e42"/><path d="M17.907,67.95243a6.35294,6.35294,0,1,1,6.35271,6.35316l-.05338-.00023a6.28592,6.28592,0,0,1-6.29967-6.27214q-.00009-.04039.00034-.08079" fill="#fff"/></svg>'

export function defaultTeamLogoURL() {
    const blob = new Blob([TEAM_DEFAULT_LOGO], {type: 'image/svg+xml'});
    return URL.createObjectURL(blob);
}

export function randomTeamName() {
    return uniqueNamesGenerator({
        dictionaries: [DETERMINANTS, MLB_PLAYERS, HEROIC_ADJECTIVES],
        style: 'capital',
        separator: ' '
    }); // Strong Babe Ruth
}

export const PARTNER_DEFAULT_LOGO =
`<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 370 370" enable-background="new 0 0 370 370" xml:space="preserve">
<g>
    <path fill="#5D3512" d="M329.994,191.643c0.992,80.285-65.913,147.918-149.406,146.328C103.329,336.5,34.34,273.538,37.112,185.32
        c1.123-35.754,14.202-67.311,38.649-93.463c32.114-34.354,72.242-49.724,119.079-46.808
        C264.511,49.387,330.835,109.086,329.994,191.643z M183.704,59.992c-34.739,0.241-67.787,13.131-93.744,39.726
        c-24.604,25.21-37.433,56.08-37.664,91.101c-0.211,32.046,10.493,61.093,31.649,85.523c26.216,30.273,59.994,46.168,99.761,46.303
        c35.274,0.119,66.609-12.827,91.796-37.91c26.913-26.801,40.62-59.811,39.324-97.842C312.5,118.629,257.07,60.821,183.704,59.992z"
        />
    <circle fill="#024569" cx="182.044" cy="191" r="119.317"/>
    <path display="none" fill="#FAFBF7" d="M183.704,59.992c73.367,0.829,128.796,58.637,131.123,126.902
        c1.296,38.031-12.41,71.041-39.324,97.842c-25.187,25.082-56.522,38.029-91.796,37.91c-39.767-0.135-73.545-16.03-99.761-46.303
        c-21.157-24.43-31.86-53.477-31.649-85.523c0.231-35.021,13.06-65.892,37.664-91.101C115.917,73.123,148.965,60.233,183.704,59.992
        z M183.478,308.027c62.857,1.352,121.871-52.404,117.584-125.304c-3.43-58.319-51.48-107.467-112.597-109.812
        c-69.882-2.682-119.809,52.473-122.59,110.812C62.428,256.045,120.003,309.099,183.478,308.027z"/>
    <path display="none" fill="#8DBC57" d="M183.478,308.027c-63.475,1.071-121.05-51.983-117.603-124.304
        c2.781-58.339,52.707-113.493,122.59-110.812c61.116,2.345,109.167,51.493,112.597,109.812
        C305.349,255.623,246.335,309.38,183.478,308.027z M131.977,237.014c0.868-1.736,1.705-3.488,2.612-5.204
        c2.247-4.253,1.157-8.269-2.981-10.86c-8.68-5.434-16.039-2.603-18.347,7.251c-0.692,2.956-0.262,5.764,2.482,8.053
        c6.501,5.424,10.045,5.692,16.317,0.668c0.076,0.319,0.227,0.64,0.216,0.955c-0.276,7.682,2.308,11.482,10.123,13.669
        c6.051,1.693,7.692-3.375,10.108-7.259c1.606-2.583,3.674-4.88,5.536-7.305c-1.82,3.302-3.599,6.626-5.47,9.899
        c-1.939,3.392-3.607,7.01-0.499,10.341c7.084,7.592,13.21,7.043,18.904-1.326c0.257-0.378,0.693-0.633,1.046-0.945
        c-0.241,1.081-0.299,2.247-0.753,3.23c0,0-0.563,1,6.707,5.068c1.011,0.565,3.066-1.081,4.068-0.5c3.721,2.158,1.878,3.228,3.919,0
        c4.053-6.408,9.537-5.109,12.877-11.906c2.442-4.97,1.826-8.117-2.052-11.51c-3.977-3.48-9.81-3.684-14.823-0.272
        c0.727-4.787,2.382-9.494-2.691-13.428c-5.358-4.155-11.541-3.592-15.047,2.022c-1.993,3.191-4.165,6.269-6.257,9.398
        c0.504-1.67,1.244-3.311,1.455-5.017c0.3-2.417,0.992-5.203,0.144-7.267c-2.722-6.624-13.664-8.749-17.146-3.512
        c-2.709,4.075-4.886,8.499-7.449,12.677C134.245,235.126,132.991,235.997,131.977,237.014z M225.998,220.003
        c4.87,2.605,9.675,5.342,14.628,7.778c4.592,2.259,7.747,1.331,10.435-3.127c1.319-2.187,2.12-4.723,2.914-7.179
        c1.11-3.434-0.086-5.815-3.343-7.614c-4.987-2.754-9.761-5.893-14.626-8.869c0,0-0.062,0.053-0.062,0.053
        c5.196,2.358,10.371,4.768,15.596,7.06c4.738,2.079,8.431,1.33,10.385-2.093c0.972-1.703,1.733-3.535,2.502-5.345
        c1.942-4.569,1.063-7.831-3.073-10.506c-2.626-1.698-5.479-3.04-8.197-4.6c-16.418-9.425-32.876-18.78-49.21-28.347
        c-6.026-3.529-12.008-1.641-13.873,5.054c-1.549,5.561-2.79,11.209-4.099,16.835c-2.097,9.011-4.794,11.158-13.903,9.773
        c-3.996-0.608-7.974-2.036-11.67-3.727c-4.648-2.126-6.156-6.18-4.927-11.199c1.096-4.474,2.667-8.891,3.212-13.431
        c1.407-11.724,5.164-21.725,16.576-27.413c2.536-1.264,2.015-3.696-0.803-3.934c-3.775-0.319-8.21-0.897-11.336,0.675
        c-9.41,4.732-18.346,10.412-27.417,15.807c-3.601,2.142-7.138,2.918-11.37,1.716c-12.059-3.426-24.214-6.511-36.331-9.734
        c-3.944-1.049-7.204-1.025-8.378,4.036c-0.588,2.534-1.924,4.897-2.933,7.332c-4.917,11.864-7.383,24.278-7.602,37.057
        c-0.122,7.104,0.469,14.24,1.155,21.322c0.134,1.387,1.961,3.339,3.382,3.759c11.389,3.364,22.837,6.541,34.339,9.499
        c3.346,0.861,6.668,0.914,9.091-2.927c0.987-1.564,3.9-2.507,6.009-2.648c4.66-0.311,8.711,1.438,11.747,5.23
        c1.984,2.479,3.595,3.331,5.906-0.219c3.016-4.633,7.007-5.586,12.164-3.457c2.371,0.979,4.596,2.592,6.504,4.337
        c2.284,2.09,3.864,3.593,6.925,0.688c1.474-1.399,5.152-2.221,6.801-1.351c4.226,2.229,8.736,4.916,11.485,8.637
        c2.241,3.034,3.844,4.794,7.764,5.374c8.963,1.326,13.094,10.422,8.85,18.189c-0.467,0.855-0.726,2.814-0.523,2.897
        c2.734,1.119,5.777,3.158,8.333,2.696c5.624-1.017,7.086-6.28,8.338-11.098c1.016-3.911-1.585-6.014-4.484-7.852
        c-0.369-0.234-0.528-0.8-0.785-1.212l-0.074,0.08c3.945,1.976,7.901,3.932,11.833,5.934c5.614,2.857,10.578,1.339,13.694-4.225
        c2.922-5.217,1.462-10.611-3.45-13.732c-2.824-1.795-5.398-3.984-8.084-5.996L225.998,220.003z M298.178,189.279
        c-0.56-5.218-0.542-11.798-2.093-17.985c-2.595-10.354-6.193-20.457-9.364-30.667c-1.076-3.465-3.724-4.138-6.726-3.351
        c-10.541,2.763-21.095,5.511-31.523,8.663c-4.302,1.3-7.822,0.992-11.729-1.295c-11.244-6.583-22.655-12.885-34.082-19.148
        c-4.802-2.632-9.64-2.754-14.285,0.746c-6.183,4.659-12.688,8.924-18.589,13.91c-2.495,2.108-4.547,5.391-5.508,8.534
        c-2.403,7.864-4.222,15.92-5.931,23.973c-0.491,2.311-0.448,5.146,0.465,7.259c1.912,4.431,11.242,7.791,17.118,6.896
        c5.756-0.876,4.082-5.313,8.038-9.884c3.864-4.465,2.435-11.68,4.763-17.04c3.179-7.318,8.388-8.592,15.174-4.832
        c0.289,0.16,0.607,0.269,0.893,0.433c19.686,11.291,39.327,22.662,59.1,33.797c3.079,1.734,4.05,3.907,4.125,7.119
        c0.162,6.899-3.383,11.59-8.877,15.033c-3.469,2.175-1.705,5.322-1.628,8.062c0.008,0.292,3.378,1.052,4.946,0.65
        c10.063-2.582,20.007-5.637,30.104-8.066c3.232-0.777,4.029-2.758,4.294-5.204C297.451,201.446,297.701,195.974,298.178,189.279z"
        />
    <path fill="#FAFBF7" d="M226.012,219.984c2.686,2.012,5.26,4.201,8.084,5.996c4.912,3.122,6.372,8.516,3.45,13.732
        c-3.116,5.563-8.081,7.082-13.694,4.225c-3.932-2.001-7.888-3.957-11.833-5.934c-0.876-0.583-1.75-1.17-2.64-1.73
        c-0.037-0.024-0.234,0.206-0.357,0.318c1.023,0.444,2.047,0.888,3.07,1.333c0.256,0.412,0.415,0.978,0.785,1.212
        c2.899,1.838,5.501,3.941,4.484,7.852c-1.252,4.818-2.714,10.081-8.338,11.098c-2.556,0.462-5.599-1.577-8.333-2.696
        c-0.203-0.083,0.055-2.042,0.523-2.897c4.243-7.767,0.113-16.863-8.85-18.189c-3.92-0.58-5.523-2.34-7.764-5.374
        c-2.749-3.721-7.259-6.408-11.485-8.637c-1.65-0.87-5.327-0.048-6.801,1.351c-3.061,2.906-4.641,1.402-6.925-0.688
        c-1.907-1.745-4.133-3.358-6.504-4.337c-5.157-2.129-9.148-1.176-12.164,3.457c-2.311,3.55-3.922,2.697-5.906,0.219
        c-3.036-3.792-7.087-5.541-11.747-5.23c-2.109,0.141-5.022,1.084-6.009,2.648c-2.423,3.841-5.745,3.788-9.091,2.927
        c-11.501-2.958-22.95-6.135-34.339-9.499c-1.421-0.42-3.248-2.371-3.382-3.759c-0.686-7.081-1.276-14.217-1.155-21.322
        c0.219-12.78,2.685-25.193,7.602-37.057c1.009-2.435,2.345-4.797,2.933-7.332c1.174-5.061,4.434-5.085,8.378-4.036
        c12.117,3.223,24.272,6.308,36.331,9.734c4.232,1.202,7.769,0.426,11.37-1.716c9.071-5.395,18.007-11.075,27.417-15.807
        c3.126-1.572,7.561-0.994,11.336-0.675c2.818,0.238,3.339,2.669,0.803,3.934c-11.412,5.688-15.169,15.689-16.576,27.413
        c-0.545,4.54-2.116,8.956-3.212,13.431c-1.229,5.018,0.279,9.072,4.927,11.199c3.696,1.691,7.675,3.12,11.67,3.727
        c-0.435-1.626,5.973-3.126,11.446-10.876c3.332-4.718,5.007-10.171,6.556-15.732c1.865-6.695,7.847-8.584,13.873-5.054
        c16.335,9.567,32.793,18.922,49.21,28.347c2.718,1.56,5.571,2.902,8.197,4.6c4.136,2.675,5.015,5.937,3.073,10.506
        c-0.769,1.81-1.53,3.642-2.502,5.345c-1.954,3.424-5.647,4.172-10.385,2.093c-5.225-2.292-10.4-4.702-15.596-7.06
        c-1.154-0.949-2.308-1.899-3.48-2.826c-0.007-0.006-0.266,0.306-0.408,0.47c1.157,0.762,2.31,1.531,3.476,2.278
        c0.116,0.074,0.314-1.34,0.474-1.335c4.865,2.976,9.639,7.476,14.626,10.23c3.257,1.799,4.453,4.18,3.343,7.614
        c-0.794,2.456-1.596,4.992-2.914,7.179c-2.688,4.457-5.842,5.386-10.435,3.127c-4.953-2.436-9.758-5.172-14.628-7.778
        c-1.546-0.823-3.092-1.646-4.638-2.469c-0.067,0.227-0.207,0.646-0.189,0.653C222.776,218.806,224.394,219.394,226.012,219.984z"/>
    <path fill="#FAFBF7" d="M298.178,189.279c-0.477,6.694-0.727,12.167-1.316,17.603c-0.265,2.447-1.063,4.427-4.294,5.204
        c-10.097,2.428-20.042,5.484-30.104,8.066c-1.568,0.402-4.938-0.357-4.946-0.65c-0.076-2.74-1.841-5.887,1.628-8.062
        c5.494-3.443,9.039-8.134,8.877-15.033c-0.076-3.212-1.046-5.385-4.125-7.119c-19.774-11.135-39.414-22.506-59.1-33.797
        c-0.286-0.164-0.604-0.273-0.893-0.433c-6.785-3.76-11.994-2.486-15.174,4.832c-2.329,5.36,0.06,9.743-4.036,13.997
        c-4.683,4.864-6.965,8.342-13.057,11.864c-5.146,2.975-10.914-1.402-12.826-5.833c-0.912-2.114-0.955-4.948-0.465-7.259
        c1.71-8.052,3.528-16.109,5.931-23.973c0.961-3.144,3.013-6.427,5.508-8.534c5.901-4.985,12.406-9.251,18.589-13.91
        c4.645-3.5,9.483-3.378,14.285-0.746c11.427,6.263,22.838,12.565,34.082,19.148c3.907,2.287,7.427,2.596,11.729,1.295
        c10.428-3.152,20.981-5.9,31.523-8.663c3.002-0.787,5.65-0.113,6.726,3.351c3.171,10.21,6.769,20.313,9.364,30.667
        C297.636,177.481,297.618,184.061,298.178,189.279z"/>
    <path fill="#FAFBF7" d="M172.023,254.952c-0.353,0.312-0.811,0.554-1.046,0.945c-6.977,11.603-13.545,11.345-20.629,3.754
        c-3.109-3.331,0.286-9.377,2.224-12.769c1.87-3.273,3.65-6.597,5.47-9.899c0,0-0.07,0.071-0.07,0.071
        c2.092-3.129,4.264-6.207,6.257-9.398c3.506-5.615,9.689-6.177,15.047-2.022c5.073,3.934,3.418,8.641,2.691,13.428l0.078-0.092
        c-1.356,2.362-2.712,4.724-4.068,7.086l0.068-0.086c-1.03,1.352-2.06,2.704-3.09,4.057l0.067-0.077
        c-1.022,1.696-2.045,3.392-3.067,5.088L172.023,254.952z"/>
    <path fill="#FAFBF7" d="M181.966,239.062c5.013-3.412,10.846-3.207,14.823,0.272c3.878,3.393,4.494,6.539,2.052,11.51
        c-3.34,6.797-4.081,8.262-8.134,14.67c-2.042,3.228-6.975,6.144-10.696,3.986c-1.002-0.581-2.642-1.485-3.511-2.25
        c-4.545-4-5.23-9.068-4.718-11.217c0.454-0.983,0,0,0.241-1.081l-0.068,0.085c1.022-1.696,2.045-3.392,3.067-5.088l-0.067,0.077
        c1.03-1.352,2.06-2.704,3.09-4.057l-0.068,0.086c1.356-2.362,2.712-4.724,4.068-7.086L181.966,239.062z"/>
    <path fill="#FAFBF7" d="M131.977,237.014c1.014-1.018,2.268-1.888,2.999-3.079c2.563-4.177,4.74-8.602,7.449-12.677
        c3.482-5.238,14.424-3.112,17.146,3.512c0.848,2.064,0.156,4.85-0.144,7.267c-0.212,1.706-0.951,3.347-1.455,5.017l0.07-0.071
        c-1.861,2.425-3.929,4.721-5.536,7.305c-2.415,3.884-6.705,16.905-12.756,15.212c-7.816-2.186-14.25-7.007-7.475-21.623
        c0.133-0.286-0.14-0.637-0.216-0.955C132.059,236.922,131.977,237.014,131.977,237.014z"/>
    <path fill="#FAFBF7" d="M132.059,236.922c-6.272,5.024-9.817,4.756-16.317-0.668c-2.744-2.289-3.174-5.097-2.482-8.053
        c2.308-9.853,9.667-12.684,18.347-7.251c4.138,2.591,5.228,6.607,2.981,10.86c-0.906,1.716-1.743,3.468-2.612,5.204
        C131.977,237.014,132.059,236.922,132.059,236.922z"/>
    <path fill="#8DBC57" d="M236.006,200.992c-0.16-0.006-0.358,0.048-0.474-0.026c-1.166-0.747-2.319-1.516-3.476-2.278
        c0.141-0.164,0.4-0.475,0.408-0.47c1.172,0.927,2.325,1.877,3.48,2.826C235.944,201.045,236.006,200.992,236.006,200.992z"/>
    <path fill="#8DBC57" d="M226.012,219.984c-1.617-0.59-3.236-1.178-4.842-1.798c-0.018-0.007,0.123-0.426,0.189-0.653
        c1.546,0.823,3.092,1.646,4.638,2.469L226.012,219.984z"/>
    <path fill="#8DBC57" d="M212.093,237.923c-1.023-0.444-2.047-0.889-3.07-1.333c0.123-0.112,0.319-0.341,0.357-0.318
        c0.89,0.56,1.764,1.148,2.64,1.73C212.019,238.003,212.093,237.923,212.093,237.923z"/>
    <path fill="#8DBC57" d="M182.045,238.969c-1.356,2.362-2.712,4.724-4.068,7.086C179.333,243.693,180.689,241.331,182.045,238.969z"
        />
    <path fill="#8DBC57" d="M175.021,249.949c-1.022,1.696-2.045,3.392-3.067,5.088C172.977,253.34,173.999,251.645,175.021,249.949z"
        />
    <path fill="#8DBC57" d="M178.045,245.969c-1.03,1.352-2.06,2.704-3.09,4.057C175.984,248.674,177.015,247.322,178.045,245.969z"/>
</g>
</svg>`

export function defaultPartnerLogoURL() {
    const blob = new Blob([PARTNER_DEFAULT_LOGO], {type: 'image/svg+xml'});
    return URL.createObjectURL(blob);
}


export function sponsorTypeEnumToDisplayName(v: SPONSOR_TYPES_VALUES): string {
    switch(v) {
        case SPONSOR_TYPES.NONE: return 'Aucun';
        case SPONSOR_TYPES.BRONZE: return 'Bronze';
        case SPONSOR_TYPES.SILVER: return 'Argent';
        case SPONSOR_TYPES.GOLD: return 'Or';
        case SPONSOR_TYPES.PLATINUM: return 'Platine';
    }
    return '';
}

export function sponsorTypeDisplayNameToEnum(v: string): SPONSOR_TYPES_VALUES {
    switch(v) {
        case 'Aucun': return SPONSOR_TYPES.NONE;
        case 'Bronze': return SPONSOR_TYPES.BRONZE;
        case 'Argent': return SPONSOR_TYPES.SILVER;
        case 'Or': return SPONSOR_TYPES.GOLD;
        case 'Platine': return SPONSOR_TYPES.PLATINUM;
    }
    return SPONSOR_TYPES.NONE;
}